/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var gettext  = require('mag-gettext').gettext,
    ngettext = require('mag-gettext').ngettext;

module.exports = [
    {name: '15 ' + gettext('min'), value: 900},
    {name: '30 ' + gettext('min'), value: 1800},
    {name: '1 ' + ngettext('hour', 'hours', 1), value: 3600},
    {name: '2 ' + ngettext('hour', 'hours', 2), value: 7200},
    {name: '3 ' + ngettext('hour', 'hours', 3), value: 10800},
    {name: '5 ' + ngettext('hour', 'hours', 5), value: 18000},
    {name: '10 ' + ngettext('hour', 'hours', 10), value: 36000},
    {name: '20 ' + ngettext('hour', 'hours', 20), value: 72000},
    {name: '24 ' + ngettext('hour', 'hours', 24), value: 86400}
];
